import React from 'react'
import PublicRecordsSvg from 'images/modules/Manage/i-menu-public-records.svg?raw'

export { default as PublicRecordsUrl } from 'images/modules/Manage/i-menu-public-records.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: PublicRecordsSvg}} />
)
